export default "__VITE_ASSET__KSe0AnQX__"